import type { StatePack } from './types'

/**
 * Maryland state pack, used to demo the "free baseline → sponsored overlay"
 * comparison alongside New York. Numbers reflect IC3 2025: Maryland had
 * $390M in reported losses with crypto-related cases representing ~63%
 * of those losses, the highest crypto share in the country.
 */
export const md: StatePack = {
  slug: 'md',
  name: 'Maryland',
  heroMap: 'outline',
  topScams: [
    {
      id: 'investment-fraud',
      name: 'Investment Fraud',
      blurb:
        'Crypto investment scams (often "pig butchering") account for a record share of Maryland losses. Most begin with a stranger texting "hey".',
      lossUsd: 246_000_000,
    },
    {
      id: 'business-email-compromise',
      name: 'Business Email Compromise',
      blurb:
        'Scammers impersonate executives, contractors, and title companies to redirect wire transfers in real-estate closings.',
      lossUsd: 65_000_000,
    },
    {
      id: 'tech-support',
      name: 'Tech Support Scams',
      blurb:
        'Fake Microsoft, Apple, and bank "fraud department" calls remain a top loss category for older Marylanders.',
      lossUsd: 28_000_000,
    },
    {
      id: 'romance-scams',
      name: 'Romance Scams',
      blurb:
        'A months-long online relationship that ends in an urgent ask for help. Often a feeder for crypto investment fraud.',
      lossUsd: 22_000_000,
    },
  ],
  agencies: [
    {
      name: 'Maryland Attorney General, Consumer Protection Division',
      description: 'File a complaint or get help with a scam targeting Maryland residents.',
      url: 'https://www.marylandattorneygeneral.gov/Pages/CPD/default.aspx',
      phone: '1-888-743-0023',
    },
    {
      name: 'Maryland Office of the Commissioner of Financial Regulation',
      description: 'Report investment, banking, or lending fraud.',
      url: 'https://www.labor.maryland.gov/finance/',
      phone: '1-888-784-0136',
    },
    {
      name: 'IC3 (FBI Internet Crime Complaint Center)',
      description: 'Report internet-enabled crime and fraud.',
      url: 'https://www.ic3.gov',
    },
    {
      name: 'AARP Maryland Fraud Watch Helpline',
      description: 'Talk to a trained fraud specialist.',
      phone: '1-877-908-3360',
    },
  ],
  exampleOverrides: {
    'pv-call-bank': {
      bankName: 'M&T Bank',
      bankPhone: '1-800-724-2440',
    },
    'ws-pig-butchering': {
      cityName: 'Baltimore',
      platformName: 'a popular dating app',
    },
  },
}
